import palette from '../theme/palette';

export const STATUS_COLORS = {
  Pendiente: palette.warning.main,
  Confirmada: palette.success.main,
  Cancelada: palette.error.main,
};
